import { FiImage } from 'react-icons/fi';
import styled from 'styled-components';
import { CaptionText } from '@/utils/global-fonts';

const Img = styled.img`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  background-size: cover;
`;

const Input = styled.input``;
const Span = styled.span``;

const EditIcon = styled.span`
  bottom: 30px;
  left: 80px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  height: 30px;
  position: relative;
  background-color: ${(props) => props.theme.primaryColor};
  border: solid ${(props) => props.theme.buttonTertiaryFontColor} 2px;
`;

const NoImg = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f3f3f3;
  font-size: 35px;
  margin: 0;
`;

const ImgUploaderHolderFooter = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: normal;
  justify-content: flex-end;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  padding: 15px 25px;
`;

const ImageUploaderHolder = styled.div``;

const ImageUploaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  padding: 0;
  margin-top: 10px;
`;

const ImgHolder = styled.div`
  display: flex;
  border-radius: 3px;
  transition: width 0.3s ease-in-out;
  width: 100%;

  p {
    margin: 0 0 0 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    text-decoration-line: underline;
    color: ${(props) => props.theme.primaryColor};
    white-space: nowrap;
  }

  @media (max-width: 1490px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (hover: hover) {
    &:hover {
      .upload {
        bottom: 0;
        opacity: 1;
      }
    }
  }
`;

const UploadButton = styled.div`
  width: 100%;
  background-color: gray;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  font-size: 24px;
  bottom: -100px;
  opacity: 0;
  transition: 0.2s ease-in-out;
  position: absolute;
`;

const Header = styled.div`
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  white-space: nowrap;
  margin-right: 15px;
`;

const Label = styled.label`
  color: ${(props) =>
    props.error ? props.theme.COLOR_ERROR_TEXT : props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

const Crop = styled.div``;

const DropZone = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: ${({ $noExtras }) => ($noExtras ? '0px' : '35px 25px 35px 25px')};
  width: 100%;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${({ theme }) => theme.COLOR_GREY4};
  border-style: dashed;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  color: #000;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const CropWrapper = styled.div`
  width: 100%;
  max-height: 55vh;
  overflow-y: auto;

  margin: 0 auto;
  padding-bottom: 10px;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background: white;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.2);
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }

  scrollbar-face-color: rgba(0, 0, 0, 0.3); /* Firefox 63 compatibility */
  scrollbar-track-color: rgba(0, 0, 0, 0.2); /* Firefox 63 compatibility */
  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.2);
  scrollbar-width: thin;
`;

const CropWrapperButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 5px 15px 5px;
  height: 38px;
`;

const ImageIcon = styled(FiImage)`
  font-size: 30px;
  font-weight: bold;
`;

const DropHere = styled.div`
  justify-content: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 35px 25px 35px 25px;
  width: 100%;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${({ theme }) => theme.COLOR_GREY4};
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  color: #000;
  outline: none;
  transition: border 0.24s ease-in-out;
  height: 175px;
`;

const NoCompanyIcon = styled.img`
  height: 36px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const DropHereText = styled(CaptionText)`
  margin-top: 10px;
`;

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: center;
  width: 100%;
  margin-top: 10px;
`;

const ImageUploaderHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const ImageUploaderStyle = {
  Crop,
  CropWrapper,
  CropWrapperButtons,
  DropZone,
  EditIcon,
  Header,
  Label,
  ImageUploaderContainer,
  ImageUploaderHolder,
  Img,
  ImgHolder,
  ImgUploaderHolderFooter,
  NoImg,
  UploadButton,
  ImageIcon,
  DropHere,
  NoCompanyIcon,
  Column,
  DropHereText,
  ActionWrapper,
  Input,
  Span,
  ImageUploaderHeader,
};

export default ImageUploaderStyle;
